import { Profile } from "app/helpers/globals";


export const tachosafeTrProfile: Profile = {
    key: 'tachosafeTR',
    domains: ['tachosafe.tr', 'tachosafe.com.tr'],
    theme: 'tachosafeTR',
    apiUrl: (domain: string) => {
        return `https://api.${domain}/TachoSafe/`;
    },
    billingApiUrl: (domain: string) => {
        return `https://billing.${domain}/webProBilling`;
    },
    chartApiUrl: (domain: string) => {
        return `https://rszoft-report.${domain}/charts-generator-api/v0/`
    },
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    disabledFeatures: [],
    topBarButtons: {
        more: true,
        help: true,
        phone: true,
        rduAdmin: true,
        rduManager: false,
        t2sUpdater: true,
        tachosafeSite: true,
        changesInStructure: true,
    },
    language: {
        fallback: 'en',
        default: 'tr',
    },
    showAds: true,
    websiteTitle: 'TachoSafe - Ausis',
    staticFiles: {
        logoColor: 'assets/profiles/tachosafeTR/newLogoColored.png',
        logoBlackAndWhite: 'assets/profiles/tachosafeTR/newLogo.png',
        favicon: 'assets/profiles/tachosafeTR/favicon.ico',
        backgroundImage: 'assets/profiles/tachosafeTR/Login Page_Background_2400x1600.webp',
    },
    footerLinks: [
        {
            name: 'Mobileye Türkiye Ausis, Çarpışma Önleyici Sistemler, Araç Takip',
            url: 'https://www.ausis.com.tr/'
        }
    ],
    documentLinks: {
        termsOfService: 'https://tachosafe.ro/terms-and-conditions',
        cookieNotice: 'https://tachosafe.ro/cookie-policy',
        privacyPolicy: 'https://tachosafe.ro/confidentiality-policy',
    },
    noDriverVehicleBanner: 'normal',
    disabledReports: [],
    forceShowScheduledReports: false,
};